import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { oauthConsentMessages as messages } from './oauthConsentMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole consent page; each part uses its own slice of it */
import styles from './OAuthConsentView.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface OAuthConsentActionsProps {
  /** The warning state (design d1): Approve loses the primary look and reads "Approve anyway". */
  isWarned: boolean;
  onApprove: () => void;
  onDeny: () => void;
  isApproving: boolean;
  isDenying: boolean;
}

const path = (chunks: React.ReactNode[]) => <span className={styles.footPath}>{chunks}</span>;

/**
 * Deny and Approve, and how to remove the app later (design: oauth-consent a1, `.oc-act`,
 * `.oc-foot`). Every plan can approve.
 */
const OAuthConsentActionsComponent: React.FC<OAuthConsentActionsProps> = ({
  isWarned,
  onApprove,
  onDeny,
  isApproving,
  isDenying,
}) => {
  const intl = useIntl();
  return (
    <>
      <div className={styles.actions}>
        <SMLButton
          outline
          omitCap
          className={styles.action}
          onClick={onDeny}
          isLoading={isDenying}
          disabled={isApproving}
        >
          {intl.formatMessage(messages.deny)}
        </SMLButton>
        <SMLButton
          outline={isWarned}
          omitCap
          className={clsx(styles.action, !isWarned && styles.actionPrimary)}
          onClick={onApprove}
          isLoading={isApproving}
          disabled={isDenying}
        >
          {intl.formatMessage(isWarned ? messages.approveAnyway : messages.approve)}
        </SMLButton>
      </div>
      <p className={styles.foot}>{intl.formatMessage(messages.foot, { b: path })}</p>
    </>
  );
};

export const OAuthConsentActions = TypedMemo(OAuthConsentActionsComponent);
